import React, { Fragment } from "react";
import queryString from "query-string-for-all";
import Helmet from "react-helmet";
import { withRouter, RouteComponentProps } from "react-router";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import * as authActions from "../../redux/modules/auth/actionCreators";
import Login from "../../components/Auth/Login";
import { AuthAction } from "redux/modules/auth/actionTypes";

interface ConnectedProps {
  user: Insite.AppState["auth"]["user"];
  error: Insite.AppState["auth"]["loginError"];
  isSubmitting: Insite.AppState["auth"]["loggingIn"];
}

interface DispatchedProps {
  login_keycloak:(username:string, token:string)=> AuthAction;
}

type Props = RouteComponentProps & {
  location: { fromPasswordResetSuccess: boolean };
} & ConnectedProps &
  DispatchedProps;

const LoginScene = ({ login_keycloak, error, isSubmitting, user, location }: Props) => {
  if (user && user.token && user.access) {
    const qs = queryString.parse(location.search);
    const defaultPath = user.access.includes("viewTriagePage")
      ? "/analysis/insights"
      : "/actions";
    /**
     * The regex here is to remove the query param `redirect` while keeping the rest params
     * so after user successfully log in, url will take the user to the right view.
     */
    const redirect = qs.redirect
      ? location.search.replace(/\?redirect=/, "")
      : defaultPath;
    return <Redirect to={redirect} />;
  }

  return (
    <Fragment>
      <Helmet title="Login" />
      <Login
        handleLogin={login_keycloak}
        error={error}
        isSubmitting={isSubmitting}
        fromPasswordResetSuccess={location.fromPasswordResetSuccess}
      />
    </Fragment>
  );
};

const mapStateToProps = (state: Insite.AppState) => ({
  user: state.auth.user,
  error: state.auth.loginError,
  isSubmitting: state.auth.loggingIn,
});

const mapDispatchToProps = { ...authActions };

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LoginScene)
);
